import axios from 'axios';

import {
  DEMO_CLAIM,

  DEMO_CLAIM_ITEM_REMOVE,
  DEMO_CLAIM_ITEM_REMOVE_SUCCESS,

  DEMO_DEPENDANT_ADD,
  DEMO_DEPENDANT_REMOVE,

  DEMO_PATIENT_ADD,
  DEMO_PATIENT_REMOVE,

  DEMO_UPDATE_PERSONAL,

  DEMO_CLAIM_ITEM_ADD,
  DEMO_CLAIM_ITEM_ADD_SUCCESS,
  DEMO_CLAIM_ITEM_ADD_FAIL,

  DEMO_CLAIM_SUBMIT,
  DEMO_CLAIM_SUBMIT_FAIL,
  DEMO_CLAIM_SUBMIT_SUCCESS,

  DEMO_LOGIN_FAIL,
  DEMO_LOGIN_SUCCESS,

  DEMO_SET_FIELD,

  SNACKBAR_SET,

  DEMO_CLAIM_ITEM_CLEAR,

  DEMO_CLEAR
} from './types';

import history from '../utility/common/History.js';

const { REACT_APP_API_URL } = process.env;

/*------------------ Demo ----------------*/
export const demoSetField = (inputGroup, inputName, inputValue) => {
  return (dispatch) => {
    dispatch({ type: DEMO_SET_FIELD, datagroup: inputGroup, dataname: inputName, datavalue: inputValue });
  };
};

/*------------------ Demo Clear ----------------*/

export const clearDemo = () => {
  return (dispatch) => {
    dispatch({ type: DEMO_CLEAR });
  };
}

/*------------------ Demo Login ----------------*/

export const demoSaveLogin = (loginInfo) => {
  return (dispatch) => {
    let planData = {};
    if(loginInfo.product == 'incorp'){
      planData = {
        FUNDING_CODE: 5,
        CONTRACT_TYPE: 20,
      }
    } else {
      planData = {
        FUNDING_CODE: 4,
        CONTRACT_TYPE: 13,
      }
    }
    dispatch({
      type: DEMO_UPDATE_PERSONAL,
      user: {
        'FIRST_NAME': loginInfo.firstname,
        'EMAIL': loginInfo.email,
        'PRODUCT': loginInfo.product,
        'PROVINCE': loginInfo.province,
        'HUTK': loginInfo.hubspotID,
        ...planData
      }
    });

    const data = {firstname: loginInfo.firstname, email: loginInfo.email, product: loginInfo.product, province: loginInfo.province, hubspotID: loginInfo.hubspotID};
    const responseDispatches = { fail: DEMO_LOGIN_FAIL, success: DEMO_LOGIN_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const showSnackBar = { fail: false, success: false };

    demoRequest(dispatch, `/login`, data, responseDispatches, responseRedirects, showSnackBar);

    return history.push('/demo/claims');

  };
}

/*------------------ Demo Redirect ----------------*/

const setDemoSnackBar = (dispatch, message='', success=false) =>{
  if(message !== ''){
    dispatch({
      type: SNACKBAR_SET,
      message: message,
      severity: (success)? 'notificationBarSuccess':'notificationBarFailed',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
}
/*-------------------------------------------------------*/
export const redirectToDemo = (url, message='', success=false) => {
  return (dispatch) => {
    setDemoSnackBar(dispatch, message, success);
    return history.push(url);
  }
}

/*-------------------------------------------------------*/

export const demoSavePersonal = (personalInfo) => {
  return (dispatch) => {
    dispatch({ type: DEMO_UPDATE_PERSONAL, user: personalInfo });
    setDemoSnackBar(dispatch, 'Saved personal information', true);
    return history.push('/demo/claims');
  };
}

/*-------------------------------------------------------*/

export const setDemoModal = (name, value, state) => {
  return (dispatch) => {
    dispatch({ type: DEMO_SET_FIELD,
      datagroup: '',
      dataname: 'modalForm',
      datavalue: {
        componentName: name,
        data: value,
        open: state
      }
    });
  };
}

/*-------------------------------------------------------*/

export const toggleDemoModal = (value) => {
  return (dispatch) => {
    dispatch({ type: DEMO_SET_FIELD,
      datagroup: 'modalForm',
      dataname: 'open',
      datavalue: value
    });
  };
}

/*-------------------------------------------------------*/

export const demoAddNewDependant = (newDep) => {
  return (dispatch) => {
    dispatch({ type: DEMO_DEPENDANT_ADD,
      dependant: newDep
    });
    dispatch({ type: DEMO_PATIENT_ADD,
      patient: newDep
    });
    dispatch({ type: DEMO_SET_FIELD,
      datagroup: 'modalForm',
      dataname: 'open',
      datavalue: false
    });
    dispatch({
      type: SNACKBAR_SET,
      message: 'Successfully added new Dependant',
      severity: 'notificationBarSuccess',
      horizontal: 'center',
      vertical: 'bottom',
    });
  };

  //TODO  save to demo reducer / state
  //TODO  add patient ...
}

/*-------------------------------------------------------*/

export const demoTerminateThisDependant  = (termDep) => {
  return (dispatch) => {
    dispatch({ type: DEMO_DEPENDANT_REMOVE,
      dependant: termDep
    });
    dispatch({ type: DEMO_PATIENT_REMOVE,
      dependant: termDep
    });
    dispatch({ type: DEMO_SET_FIELD,
      datagroup: 'modalForm',
      dataname: 'open',
      datavalue: false
    });
    dispatch({
      type: SNACKBAR_SET,
      message: 'Successfully removed Dependant',
      severity: 'notificationBarSuccess',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
  //TODO remove dep from demo reducer / state
  //TODO remove patient ...
}

/*------------------ Demo Start Claims ----------------*/
export const demoStartClaim = () => {
  return (dispatch) => {
    dispatch({
      type: DEMO_CLAIM,
    });
    //TODO get services
  };
};

/*-------------------------------------------------------*/

export const demoClaimItemClear = () => {
  return (dispatch) => {
    dispatch({ type: DEMO_CLAIM_ITEM_CLEAR });
  }
}

/*-------------------------------------------------------*/

export const demoClaimItemAdd = (claimItem, claimDateRange, claimItems, clearPageItem) => {
  return (dispatch) => {
    dispatch({ type: DEMO_CLAIM_ITEM_ADD, claimItem });

    demoProcessClaimItemAdd(dispatch, claimItem, claimDateRange, claimItems, clearPageItem);
  }
}

/*-------------------------------------------------------*/

const demoProcessClaimItemAdd = (dispatch, claimItemObj, claimDateRangeObj, claimItems, clearPageItem) => {

  let error = false;
  let errors = {};

  const responseDispatches = { fail: DEMO_CLAIM_ITEM_ADD_FAIL, success: DEMO_CLAIM_ITEM_ADD_SUCCESS };
  const responseRedirects = { fail: null, success: null };
  const showSnackBar = { fail: true, success: false };

  //strip non numbers and priods from amount to avoid allowing weird parsefloat returns
  claimItemObj.amount = claimItemObj.amount.replace(/[^\d.-]/g, '');

  if(typeof claimItemObj !== "object") { error = true; errors.GENERAL = 'Invalid claim item'; }

  //check duplicates, had to direct value compare, object to object wasnt working
  Object.values(claimItems).map( (item, index) => {
    if(
      item.patient === claimItemObj.patient &&
      item.service_date === claimItemObj.service_date &&
      item.service === claimItemObj.service &&
      item.provider === claimItemObj.provider &&
      item.amount === claimItemObj.amount
    ) { error = true; errors.GENERAL = 'Duplicate claim item, adjust some details'; return true; }
    return false;
  });

  if(!claimItemObj.patient || claimItemObj.patient === '') { error = true; errors.patient = 'Invalid patient'; }

  if(!claimItemObj.service_date || claimItemObj.service_date === '' || isNaN(Date.parse(claimItemObj.service_date))) { error = true; errors.service_date = 'Invalid service date'; }

  if(!claimItemObj.service || claimItemObj.service === '') { error = true; errors.service = 'Invalid service type'; }

  if(!claimItemObj.provider || claimItemObj.provider === '') { error = true; errors.provider = 'Invalid provider'; }

  if(!claimItemObj.amount || claimItemObj.amount === '' || isNaN(parseFloat(claimItemObj.amount))) { error = true; errors.amount = 'Invalid amount'; }

  //basic validation checks and return so i can calculate specifics without erroring
  if(error === true) {
    errors.GENERAL = (errors.GENERAL)? errors.GENERAL : 'Please correct the claim details above!';
    demoRequestFail(
      dispatch,
      error,
      errors,
      responseDispatches.fail,
      responseRedirects.fail,
      showSnackBar.fail
    );
  }
  //advanced validation checks
  const minDateArr = claimDateRangeObj.min.split('-');
  const minDate = new Date();
        minDate.setFullYear(minDateArr[0]);
        minDate.setMonth(minDateArr[1]-1);
        minDate.setDate(minDateArr[2]);
        minDate.setHours(0,0,0,0)

  const maxDateArr = claimDateRangeObj.max.split('-');
  const maxDate = new Date();
        maxDate.setFullYear(maxDateArr[0]);
        maxDate.setMonth(maxDateArr[1]-1);
        maxDate.setDate(maxDateArr[2]);
        maxDate.setHours(23,59,59,999)

  const serviceDateArr = claimItemObj.service_date.split('-');
  const serviceDate = new Date();
        serviceDate.setFullYear(serviceDateArr[0]);
        serviceDate.setMonth(serviceDateArr[1]-1);
        serviceDate.setDate(serviceDateArr[2]);

  if(serviceDate < minDate || serviceDate > maxDate) { error = true; errors.service_date = `Invalid service date`; }

  if(parseFloat(claimItemObj.amount) > 15000) { error = true; errors.amount = `Amount exceeds $15,000`; }
  if(parseFloat(claimItemObj.amount) <= 0) { error = true; errors.amount = `Invalid amount`; }

  //add time stamps and date formating from IOS string
  claimItemObj.dateTime = serviceDate;

  if(error === false) {
    clearPageItem();
    demoRequestSuccess(
      dispatch,
      claimItemObj,
      'Claim Item has been successfully added',
      responseDispatches.success,
      responseRedirects.success,
      showSnackBar.success
    );
  } else {
    errors.GENERAL = (errors.GENERAL)? errors.GENERAL : 'Please correct the claim details above';
    demoRequestFail(
      dispatch,
      error,
      errors,
      responseDispatches.fail,
      responseRedirects.fail,
      showSnackBar.fail
    );
  }

}

/*-------------------------------------------------------*/

export const demoClaimItemRemove = (claimItem) => {
  return (dispatch) => {
    dispatch({ type: DEMO_CLAIM_ITEM_REMOVE, claimItem });
    dispatch({ type: DEMO_CLAIM_ITEM_REMOVE_SUCCESS });
    //validate return code
  }
}

/*-------------------------------------------------------*/

export const demoSubmitClaim = (userdata, claimItemsData, depdata, totals) => {
  return (dispatch) => {

    dispatch({type: DEMO_CLAIM_SUBMIT});

    const data = { userdata: userdata, claimItemsData: claimItemsData, depdata: depdata, totals: totals }
    const responseDispatches = { fail: DEMO_CLAIM_SUBMIT_FAIL, success: DEMO_CLAIM_SUBMIT_SUCCESS };
    const responseRedirects = { fail: null, success: '/demo/claims/success' };
    const showSnackBar = { fail: true, success: true };

    demoRequest(dispatch, `/claim/submit`, data, responseDispatches, responseRedirects, showSnackBar);
  }
}

/*-------------------------------------------------------*/

const demoRequest = (dispatch, endpoint, dataObj, responseDispatches, responseRedirects, showSnackBar) => {

  axios.post(`${REACT_APP_API_URL}/demo`+ endpoint, {
    data: dataObj,
  })
  .then((response) => {
    if (response.data.code === 0) {
      demoRequestSuccess(
        dispatch,
        response.data.data,
        response.data.data.message,
        responseDispatches.success,
        responseRedirects.success,
        showSnackBar.success
      );
    } else {
      demoRequestFail(
        dispatch,
        true,
        response.data.data.error,
        responseDispatches.fail,
        responseRedirects.fail,
        showSnackBar.fail
      );
    }
  })
  .catch((error) => {
    demoRequestFail(
      dispatch,
      true,
      error,
      responseDispatches.fail,
      responseRedirects.fail,
      showSnackBar.fail
    );
  });

};

/*-------------------------------------------------------*/

const demoRequestSuccess = (
  dispatch,
  data,
  message,
  responseDispatch,
  responseRedirect,
  showSnackBar
) => {
  dispatch({
    type: responseDispatch,
    data,
  });
  if(showSnackBar === true){
    dispatch({
      type: SNACKBAR_SET,
      message: message,
      severity: 'notificationBarSuccess',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
  if(responseRedirect) history.push(responseRedirect);
};

/*-------------------------------------------------------*/

const demoRequestFail = (
  dispatch,
  error,
  errors,
  responseDispatch,
  responseRedirect,
  showSnackBar
) => {
  dispatch({
    type: responseDispatch,
    error,
    errors
  });
  if(showSnackBar === true){
    dispatch({
      type: SNACKBAR_SET,
      message: errors.GENERAL,
      severity: 'notificationBarFailed',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
  if(responseRedirect) history.push(responseRedirect);
};
